import { FieldType, ConditionOption } from '../types';

export const FIELD_TYPES: FieldType[] = ['Condition', 'Yes/No', 'Free Text'];

export const DEFAULT_CONDITION_OPTIONS: Omit<ConditionOption, 'id' | 'item'>[] = [
  { label: 'Fair', value: 'fair', order: 1 },
];

export const FIELD_TYPE_DESCRIPTIONS = {
  Condition: 'Rate the condition with custom labels',
  'Yes/No': 'Simple yes or no response',
  'Free Text': 'Open text input for detailed responses',
} as const;

// Template sorting options
export const TEMPLATE_SORT_OPTIONS = [
  { value: 'title', label: 'Title' },
  { value: 'updated_at', label: 'Last Updated' },
  { value: 'sections', label: 'Number of Sections' },
  { value: 'items', label: 'Number of Items' },
] as const;

// Cache configuration constants
export const CACHE_TIMES = {
  TEMPLATES: 5 * 60 * 1000, // 5 minutes
  TEMPLATE_DETAILS: 1 * 60 * 1000, // 1 minute
  PREFETCH: 60 * 1000, // 1 minute
} as const;

// Pagination defaults
export const PAGINATION_DEFAULTS = {
  TEMPLATES_PER_PAGE: 12,
  TEMPLATES_PER_PAGE_LIST_VIEW: 20,
} as const;

// Field type priorities for ordering
export const FIELD_TYPE_PRIORITY = {
  Condition: 1,
  'Yes/No': 2,
  'Free Text': 3,
} as const;
